// 알림톡 발송 등록 뷰 상수

/** 쿠폰/기획전 피커 1페이지 조회 수 */
export const ALIMTALK_PICKER_PAGE_SIZE = 50;

/**
 * 카카오 미리보기에서 운영자 선택값이 없을 때 {{변수}}에 대신 채울 폴백.
 * ACTION 모드 변수 어휘 정본: 백엔드 ACTION_TYPE_SUPPORTED_VARS (libs/shared/constants/services/alimtalk/action-supported-vars.ts)
 * — userName·couponName·couponNameWithoutSingleQuote·discountText·couponEndDate·discountPeriod·couponId·eventId
 * - 운영자/쿠폰 선택으로 정해지는 값은 [대괄호] placeholder — "아직 안 정해짐 / 발송 시 채워짐"을 명시
 *   (discountText는 쿠폰 조회 후 백엔드가 "40%"/"5000원"으로 채우므로 placeholder 유지)
 * - per-user 값(userName)은 프론트가 알 수 없어 샘플로 표시
 * - nickname·pointIssue는 CSV 모드의 자유 변수(CSV 컬럼) 예시용 샘플
 */
export const ALIMTALK_PREVIEW_FALLBACK: Record<string, string> = {
  // 운영자/쿠폰이 정하는 값 → 미선택 시 placeholder
  couponName: '[쿠폰명]',
  couponNameWithoutSingleQuote: '[쿠폰명]',
  couponEndDate: '[종료일]',
  discountPeriod: '[유효기간]',
  discountText: '[할인 혜택]',
  // per-user 값 → 샘플
  userName: '홍길동',
  // CSV 모드 자유 변수 예시 → 샘플
  nickname: '홍길동',
  pointIssue: '3,000',
};
